import metricsUIStore from './metricsUIStore.js';
import metricsDataStore from './metricsDataStore.js';

export default {
  modules: {
    ui: metricsUIStore,
    data: metricsDataStore,
  },
};
